import React, { ReactNode, useContext, useEffect } from "react";
import axios from "axios";
import styles from "./AppShell.module.css";
import { Sidebar } from "../Sidebar";
import ErrorAlert from "../common/ErrorAlert";
import { ErrorAlertContext } from "../../context/ErrorAlert";
import { ReactComponent as CloseButton } from "../../assets/close.svg";
import {
  bankSortFunction,
  sendMessage,
} from "../../context/utils";
import { RoutingContext } from "../../context/Router";
import { UssdContext } from "../../context/Ussd";
import { ReactComponent as KlashaBlackLogo } from "../../assets/logo-black.svg";
import { ReactComponent as LockIcon } from "../../assets/lock.svg";
import { SupportFooter } from "../common/SupportFooter";

export const AppShell = ({ children }: { children: ReactNode }) => {
  const { currency, merchantKey, payData} = useContext(RoutingContext);
  const { showAlert, alertMessage, onShowAlert } =
    useContext(ErrorAlertContext);
  
  const { setUssdBankList, setUssdDetailsLoading } = useContext(UssdContext);

  const HIDE_BUTTON = payData?.kit?.hideCloseBtn
  

  const onClose = () => {
    sendMessage({ status: "ERROR" });
  };

  const getUssdBanks = async () => {
    setUssdDetailsLoading(true);
    try {
      const response = await axios(
        `${process.env.REACT_APP_API_URL}pay/v2/bank/codes`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
            ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
              })
          },
        }
      );
      const responseData = response.data;

      const sortedData = responseData
        ? responseData.sort(bankSortFunction)
        : [];
      const banksOptions = sortedData.map((dat: any) => ({
        value: dat.code,
        label: dat.name,
      }));
      setUssdBankList(banksOptions);
    } catch (err) {
      // @ts-ignore
      onShowAlert(err, err.error);
    }
    setUssdDetailsLoading(false);
  };

  

  useEffect(() => {
    if (merchantKey?.length && currency === "NGN") {
      getUssdBanks();
    }
  }, [merchantKey, currency]);

  

  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
        {!HIDE_BUTTON && <button className={styles.closBtn} onClick={onClose} type="button">
          <CloseButton className={styles.closeBtnIcon} />
        </button>}
        <Sidebar />
        <div className={styles.body}>{children}</div>
        {showAlert && <ErrorAlert message={alertMessage} />}
      </div>

      <div className={styles.securedText}>
        <LockIcon />
        <p>Secured by</p>
        <KlashaBlackLogo />
      </div>

      <div className="app-support-footer">
        <SupportFooter />
        <div className="app-support-footer-contact">
          <p>
            Email: <a href="mailto:vip-support@klasha.com">vip-support@klasha.com</a> |
            WhatsApp: <a href="https://wa.me/+14159933858"> +14159933858</a>
          </p>
        </div>
      </div>
    </div>
  );
};
